const config = {
  brands: [
    {
      name: "Şafak Usta",
      colors: {
        primary: "#0F1425",
        secondary: "#FF6A3E",
      },
      phone: {
        mobile: "0542 100 95 61",
        wp: "0532 573 43 82",
      },
    },
    {
      name: "Fuat Usta",
      colors: {
        primary: "#222831",
        secondary: "#51C4D3",
      },
      phone: {
        mobile: "0505 168 43 82",
        wp: "0532 573 43 82",
      },
    },
    {
      name: "Fatih Usta",
      colors: {
        primary: "#2A363B",
        secondary: "#FF847C",
      },
      phone: {
        mobile: "0551 483 52 41",
        wp: "0532 573 43 82",
      },
    },
    {
      name: "Yavuz Usta",
      colors: {
        primary: "#0F1425",
        secondary: "#FF6A3E",
      },
      phone: {
        mobile: "0505 208 42 05",
        wp: "0532 573 43 82",
      },
    },
    {
      name: "Asya Çilingir",
      colors: {
        primary: "#222831",
        secondary: "#51C4D3",
      },
      phone: {
        mobile: "0542 100 16 44",
        wp: "0532 573 43 82",
      },
    },
    {
      name: "Bakırköy Kilit ve Çilingir",
      colors: {
        primary: "#0F1425",
        secondary: "#FF6A3E",
      },
      phone: {
        mobile: "0542 100 26 44",
        wp: "0532 573 43 82",
      },
    },
    {
      name: "Ömer Usta",
      colors: {
        primary: "#222831",
        secondary: "#51C4D3",
      },
      phone: {
        mobile: "0551 962 55 94",
        wp: "0532 573 43 82",
      },
    },
    {
      name: "Güneş Çilingir",
      colors: {
        primary: "#2A363B",
        secondary: "#FF847C",
      },
      phone: {
        mobile: "0542 357 85 65",
        wp: "0532 573 43 82",
      },
    },
    {
      name: "Nizam Usta",
      colors: {
        primary: "#0F1425",
        secondary: "#FF6A3E",
      },
      phone: {
        mobile: "0541 334 43 82",
        wp: "0532 573 43 82",
      },
    },
    {
      name: "Çilingir Mert",
      colors: {
        primary: "#0F1425",
        secondary: "#FF6A3E",
      },
      phone: {
        mobile: "0542 163 75 48",
        wp: "0532 573 43 82",
      },
    },
    {
      name: "Metro Çilingir",
      colors: {
        primary: "#2A363B",
        secondary: "#FF847C",
      },
      phone: {
        mobile: "0542 163 43 82",
        wp: "0532 573 43 82",
      },
    },
  ],
};
export default config;
